/* Light Therapy FAQ search: filters questions by their text and answer, opens
   matches and hides empty categories. A custom element, so theme-editor section
   reloads do not stack listeners. Without JavaScript all questions show. */
(() => {
  if (customElements.get('pti-learn-faq')) return;

  const normalize = (value) =>
    (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  const format = (template, values) =>
    (template || '').replace(/\{(\w+)\}/g, (match, key) => (key in values ? values[key] : match));

  class PtiLearnFaq extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.input = this.querySelector('[data-pti-faq-input]');
      this.form = this.querySelector('[data-pti-faq-form]');
      this.status = this.querySelector('[data-pti-faq-status]');
      this.empty = this.querySelector('[data-pti-faq-empty]');
      this.clearButton = this.querySelector('[data-pti-faq-clear]');
      this.groups = Array.from(this.querySelectorAll('[data-pti-faq-group]'), (element) => ({
        element,
        items: Array.from(element.querySelectorAll('[data-pti-faq-item]'), (item) => ({
          element: item,
          text: normalize(item.dataset.search),
        })),
      }));
      if (!this.input || !this.form) return;

      this.term = '';
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.search(true);
      });
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(), 200);
      });
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          this.clear();
        }
      });
      if (this.clearButton) {
        this.clearButton.addEventListener('click', () => {
          this.clear();
          this.input.focus();
        });
      }
      this.querySelector('[data-pti-faq-search]').hidden = false;
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.statusTimer);
    }

    clear() {
      this.input.value = '';
      this.search();
    }

    search(force = false) {
      clearTimeout(this.timer);
      const term = normalize(this.input.value);
      if (term === this.term && !force) return;
      const wasSearching = Boolean(this.term);
      this.term = term;

      let count = 0;
      this.groups.forEach((group) => {
        let shown = 0;
        group.items.forEach((item) => {
          const match = !term || item.text.includes(term);
          item.element.hidden = !match;
          // Open matches while searching; close everything again when cleared.
          if (term) item.element.open = match;
          else if (wasSearching) item.element.open = false;
          if (match) shown += 1;
        });
        group.element.hidden = shown === 0;
        count += shown;
      });

      if (this.empty) this.empty.hidden = !term || count > 0;
      const raw = this.input.value.trim();
      const message = !term
        ? this.dataset.textCleared
        : count
          ? format(this.dataset.textResults, { count, noun: count === 1 ? 'question' : 'questions', term: raw })
          : format(this.dataset.textNone, { term: raw });
      this.status.textContent = '';
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => {
        this.status.textContent = message;
      }, 100);
    }
  }

  customElements.define('pti-learn-faq', PtiLearnFaq);
})();
